import React, { useMemo } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  renderPart: {
    position: "absolute",
    boxSizing: "border-box",
  },
});

function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return [d.getUTCFullYear(), weekNo];
}

const getDayNameByIdx = (idx) => {
  const days = ["", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  return days[idx];
};

export default ({ renderPart, resource, monthStrings, year, scaleRatio }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const scaledRenderPart = useMemo(() => {
    return {
      width: renderPart.size.width * scaleRatio,
      height: renderPart.size.height * scaleRatio,
      x: renderPart.position.x * scaleRatio,
      y: renderPart.position.y * scaleRatio,
    };
  }, [renderPart, scaleRatio]);

  const styles = {
    width: scaledRenderPart.width + "px",
    height: scaledRenderPart.height + "px",
    top: scaledRenderPart.y + "px",
    left: scaledRenderPart.x + "px",
  };

  const cellWidth =
    (scaledRenderPart.width - renderPart.month.colSpacing * scaleRatio * 7) /
    8;
  const cellHeight =
    (scaledRenderPart.height - renderPart.month.rowSpacing * scaleRatio * 6) /
    7;

  let pos = { left: 0, top: 0 };

  let monthNumber = 1;

  if (monthStrings[renderPart.resourceId]) {
    monthNumber = monthStrings[renderPart.resourceId].monthNumber;
  }

  const cells = [];
  for (let i = 0; i < 8; i++) {
    const text = t(getDayNameByIdx(i));
    cells.push(
      <RenderCell
        key={text}
        size={{ width: cellWidth, height: cellHeight }}
        position={{ ...pos }}
        font={renderPart.month.cells.dayheading.font}
        text={text}
        scaleRatio={scaleRatio}
      />,
    );
    pos["left"] += cellWidth + renderPart.month.colSpacing * scaleRatio;
  }

  const startDate = new Date();
  const month = new Date(year, monthNumber - 1, 1);
  const firstDayOfWeek = month.getDay();
  if (firstDayOfWeek == 0) {
    // Subtract days from sunday:
    month.setDate(month.getDate() - 6);
  } else {
    month.setDate(month.getDate() - firstDayOfWeek);
  }

  console.log("Month render part", renderPart);

  let started = false;
  for (let i = 0; i < 6; i++) {
    pos["top"] += cellHeight + renderPart.month.rowSpacing * scaleRatio;
    pos["left"] = 0;
    for (let j = 0; j < 8; j++) {
      let dayNumber = month.getDate();
      if (!started && dayNumber == 1) {
        started = true;
      } else if (started && dayNumber == 1) {
        started = false;
      }

      let type = "day";
      if (j === 0) {
        type = "week";
        const weekNumber = getWeekNumber(month);
        dayNumber = weekNumber[1];
      } else if (!started) type = "extraday";
      else if (j > 5) type = "holiday";

      month.setDate(month.getDate() + 1);

      cells.push(
        <RenderCell
          key={i + "_" + j}
          size={{ width: cellWidth, height: cellHeight }}
          position={{ ...pos }}
          font={renderPart.month.cells[type].font}
          text={dayNumber}
          scaleRatio={scaleRatio}
        />,
      );
      pos["left"] += cellWidth + renderPart.month.colSpacing * scaleRatio;
    }
  }

  return (
    <div className={classes.renderPart} style={styles}>
      {cells}
    </div>
  );
};

const RenderCell = ({ size, position, font, text, scaleRatio }) => {
  let justifyContent = "flex-start";
  switch (font.horizontalAlign) {
    case "center":
      justifyContent = "center";
      break;
    case "right":
      justifyContent = "flex-end";
      break;
  }
  let alignItems = "flex-start";
  switch (font.verticalAlign) {
    case "center":
    case "middle":
      alignItems = "center";
      break;
    case "bottom":
      alignItems = "flex-end";
      break;
  }

  console.log("Renderin gcell", position, size, position);

  const style = {
    left: position.left + "px",
    top: position.top + "px",
    width: size.width + "px",
    height: size.height + "px",
    position: "absolute",
    fontSize: font.size * scaleRatio + "pt",
    fontFamily: font.family,
    color: font.color,
    display: "flex",
    alignItems,
    justifyContent,
  };

  return <div style={style}>{text}</div>;
};
